import styled from '@emotion/styled';
import anime from 'animejs';
import { useEffect } from 'react';

import {
  Description,
  DescriptionWrapper,
  ImageBackground,
  ImageWrapper,
  Statement,
  StoryItemWrapper,
  Title,
} from './StoryItem.styled';

type Props = {};

const StoryItemFirst = (props: Props) => {
  const animateImage = () => {
    anime({
      targets: '#gummy',
      easing: 'easeInOutSine',
      duration: 1000,
      // scale: 1.1,
      translateY: '-= 15',
      direction: 'alternate', // (0% -> 100% -> 0%)
      loop: true,
    });
  };

  useEffect(() => {
    animateImage();
  }, []);
  return (
    <StoryItemWrapper>
      <ImageWrapper>
        <ImageBackground src='/images/storyImage_1.png' />
        <ImageGummy id='gummy' src='/images/gummy_young.gif' />
        <ImageLight src='/images/light.png' />
      </ImageWrapper>
      <DescriptionWrapper>
        <Title>Into the Unknown</Title>
        <Description>
          <Statement>
            4차원의 공간에서 이름 지을 수 없는 형태로 존재하는 꺼미
          </Statement>
          <Statement>
            그때 하얀 빛이 몸을 감싸고 3차원 미지의 세계로 떨어진다!
          </Statement>
          <Statement>
            ‘엇! 내몸이 바뀌네?!?! ..어떤 형태로든 바뀔 수 있잖아?!’
          </Statement>
        </Description>
      </DescriptionWrapper>
    </StoryItemWrapper>
  );
};

const ImageGummy = styled.img`
  position: absolute;
  top: 150px;
  left: 100px;
  width: 134px;
  /* width: fit-content; */
  height: 67px;
  object-fit: contain;
`;

const ImageLight = styled.img`
  position: absolute;
  top: 97px;
  left: 83px;
  width: fit-content;
  height: fit-content;
`;

export default StoryItemFirst;
